// // api/salary.js
// import { apiCall } from "./index";

// // api/salary.js
// export const uploadSalaryData = (formData, additionalParams = {}) => {
//   // Add additional parameters to FormData
//   Object.keys(additionalParams).forEach(key => {
//     formData.append(key, additionalParams[key]);
//   });
  
//   return apiCall(`/upload-salary-data`, "POST", formData, null, true);
// };

// export const getSalaryMonths = () => {
//   return apiCall(`/salary-months`);
// };

// export const getCalculatedSalaries = (salaryMonth) => {
//   return apiCall(`/calculated-salaries?salary_month=${salaryMonth}`);
// };

// export const downloadSalaryReport = (salaryMonth) => {
//   return apiCall(`/download-salary-report?salary_month=${salaryMonth}`);
// };

// api/salary.js


import { apiCall } from "./index";

export const uploadSalaryData = (formData) => {
  return apiCall(`/upload-salary-data`, "POST", formData, null, true);
};

export const getSalaryMonths = () => {
  return apiCall(`/salary-months`);
};

export const getCalculatedSalaries = (salaryMonth) => {
  return apiCall(`/calculated-salaries?salary_month=${salaryMonth}`);
};

export const downloadSalaryReport = (salaryMonth) => {
  return apiCall(`/download-salary-report?download=xlsx&salary_month=${salaryMonth}`);
};